const prefix = 'sectionhelper';

export const dataHooks = {
  prefix: `${prefix}-prefix`,
  closeButton: `${prefix}-close-btn`,
  title: `${prefix}-title`,
  content: `${prefix}-content`,
  actionButton: `${prefix}-action-btn`,
  secondaryActionButton: `${prefix}-secondary-action-btn`,
};

export const SKIN = {
  Warning: 'warning',
  Standard: 'standard',
  Danger: 'danger',
  Success: 'success',
  Premium: 'premium',
  Preview: 'preview',
  ExperimentalDark: 'experimentalDark',
} as const;

export const SIZE = {
  Small: 'small',
  Medium: 'medium',
} as const;

export const LAYOUT = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
} as const;

export const BORDER = {
  Standard: 'standard',
  TopBottom: 'topBottom',
} as const;
